<template>
  <section class="min-h-screen flex flex-col snap-start bg-amber-50 px-6">
    <div class="flex-1 flex items-center justify-center">
      <div class="max-w-2xl mx-auto text-center">
        <Image
          :src="Logo"
          alt="Symphony"
          width="240"
          class="mx-auto mb-6"
        />
        <p class="text-xl text-gray-700 mb-6">
          Launching 2026
        </p>
        <div class="flex flex-wrap gap-3 justify-center">
          <Button
            label="Log in"
            icon="pi pi-sign-in"
            class="p-button-outlined"
            @click="router.push('/login')"
          />
          <Button
            label="Create account"
            icon="pi pi-user-plus"
            @click="router.push('/register')"
          />
        </div>
      </div>
    </div>
    <p class="text-center text-gray-600 pb-10 text-lg">
      <span class="inline-block text-left">
        Rental Software built for the
        <span class="inline-block font-bold text-gray-800 ml-1 min-w-[13rem] text-left">{{ currentRole }}</span>
      </span>
    </p>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import Logo from '@/assets/logos/Symphony_Logo_Vertical_RGB.png';

const router = useRouter();

const roles = [
  'company director',
  'project manager',
  'crew booker',
  'transport manager',
  'warehouse staff',
  'driver',
  'finance staff',
  'project coordinator',
  'freelance staff',
  'crew chief'
];

const currentRole = ref(roles[0]);
let intervalId = null;

onMounted(() => {
  let index = 0;
  intervalId = setInterval(() => {
    index = (index + 1) % roles.length;
    currentRole.value = roles[index];
  }, 500);
});

onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
});
</script>
